// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__1hDGG","error":"Textarea_error__2Dtwg","borderless":"Textarea_borderless__yOEv5"};